import { ThemeUICSSObject } from 'theme-ui';

export enum MESSAGE_VARIANT {
  info = 'info',
  warning = 'warning',
  success = 'success',
  white = 'white',
}

const defaultMessageStyles: ThemeUICSSObject = {
  variant: 'text.sm',
  border: `0px solid`,
  borderRadius: '0px',
  padding: 3,
  paddingLeft: 5,
  boxShadow: 'xs',
  textDecoration: 'none',
};

export const messages: Record<MESSAGE_VARIANT, ThemeUICSSObject> = {
  info: {
    ...defaultMessageStyles,
    backgroundColor: 'blueScale.1',
    color: 'blueScale.4',
  },
  warning: {
    ...defaultMessageStyles,
    backgroundColor: 'warningScale.1',
    color: 'warningScale.4',
  },
  success: {
    ...defaultMessageStyles,
    backgroundColor: 'successScale.1',
    color: 'successScale.4',
  },
  white: {
    ...defaultMessageStyles,
    backgroundColor: 'white',
  },
};
